import { CurrencyPipe } from "@angular/common";
import { Address, BasketSummary, BasketSummaryDetails, CurrentTransactionDetails, Customer, DELIVERY_METHODS, PROMOTION_LEVEL, PROMOTION_TYPE, INITIATING_MODULE, LinePromotions, OrderDetails, PROVIDERS, ShipmentDetails, TRANSACTION_TYPE, TransactionDocument, TransactionInfo, TransactionPromotion, Trigger, externalTransactionDetails, TProduct, RefundProductChange, Product } from "./mapper-library.model";
import { NumberUtilService } from "./number-util.service";
import { AppLoggerService } from '@pmcretail/common-services/common/app-logger.service';

export class WebReturnSalesforceMapperBuilderClass {

    className = "WebReturnSalesforceMapperBuilderClass";
    private orderDetails: OrderDetails;
    private webReturnObject: TransactionDocument = {
        id: '',
        orgCode: "",
        storeId: "",
        storeNodeId: "",
        storeNodeStructure: "",
        deviceId: "",
        terminalId: "",
        initiatingModule: "",
        export: false,
        isInStoreOrder: false,
        basket: {},
        basketSummary: {},
        baseCurrency: "",
        customer: {
            id: '',
            email: '',
            firstName: '',
            lastName: '',
            billingAddress: [],
            shippingAddress: [],
            shipmentDetails: [],
            telephone: '',
            postCode: '',
            noCustomerSelected: false
        },
        currentTransactionDetails: {} as CurrentTransactionDetails
    }
    numberUtilService: any;
    public STORE_PREFIX = 'store@';
    constructor(orderDetails: OrderDetails,
        private currencyPipe?: CurrencyPipe
    ) {
        if (orderDetails) {
            this.orderDetails = orderDetails;
        }
        this.numberUtilService = new NumberUtilService(currencyPipe);
    }

    webReturnCommonMapper() {
        AppLoggerService.logDebug(this.className, "webReturnCommonMapper", "Mapper library: WebReturnSalesforceMapperBuilderClass: webReturnCommonMapper started...");
        this.webReturnObject['type'] = TRANSACTION_TYPE.WEB_RETURNS;
        this.webReturnObject['datetime'] = this.getUTCDateTime(this.orderDetails.last_modified);
        this.webReturnObject.baseCurrency = this.orderDetails.currency;
        this.webReturnObject.subsidiaryId = '1';
        this.webReturnObject.export = true;
        this.webReturnObject.initiatingModule = INITIATING_MODULE.EBASKET;
        this.webReturnObject.createdAt = this.getUTCDateTime(this.orderDetails.creation_date);
        this.webReturnObject.updatedAt = this.getUTCDateTime(this.orderDetails.last_modified);
        this.webReturnObject.transCompletedAt = this.getUTCDateTime(this.orderDetails.last_modified);
        this.webReturnObject['externalTransactionId'] = this.orderDetails.order_no;
        AppLoggerService.logDebug(this.className, "webReturnCommonMapper", "webReturnCommonMapper ended...");
        return this;
    }

    // export(status, details) {
    //     AppLoggerService.logDebug(this.className, "Mapper library: WebReturnSalesforceMapperBuilderClass: export mapping started...");
    //     AppLoggerService.logDebug(this.className, "Mapper library: WebReturnSalesforceMapperBuilderClass: status:", status);
    //     AppLoggerService.logDebug(this.className, "Mapper library: WebReturnSalesforceMapperBuilderClass: details:", JSON.stringify(details));
    //     if (status && details && details.providers && details.providers.length > 0) {
    //         details.providers.forEach(
    //             providerObj => {
    //                 if (providerObj.provider && providerObj.provider === PROVIDERS.SALESFORCE) {
    //                     this.webReturnObject.export = true;
    //                 } else {
    //                     this.webReturnObject.export = false;
    //                 }
    //             }
    //         );
    //     } else {
    //         this.webReturnObject.export = false;
    //     }
    //     AppLoggerService.logDebug(this.className, "Mapper library: WebReturnSalesforceMapperBuilderClass: export mapping end...")
    //     return this;
    // }

    getDeliveryMethod() {
        if (this.orderDetails.shipments && this.orderDetails.shipments.length > 0) {
            const shipToStoreShipment = this.orderDetails.shipments.find(shipment => shipment.c_fromStoreId);
            if (shipToStoreShipment) return DELIVERY_METHODS.SHIP_TO_STORE;
            else return DELIVERY_METHODS.DELIVERY;
        } else {
            return '';
        }
    }

    product(subprovider) {
        AppLoggerService.logDebug(this.className, "product", "product mapping started...");
        this.webReturnObject.basket['products'] = [];
        if (this.orderDetails.product_items && this.orderDetails.product_items.length > 0) {
            this.orderDetails.product_items.forEach(
                (product, index) => {
                    let productObj: any = {
                        description: product.item_text ? product.item_text : '',
                        SKU: product.product_id ? product.product_id : '',
                        quantity: product.quantity ? product.quantity : 0,
                        refundedQuantity: 0,
                        price: product.base_price ? product.base_price : 0,
                        itemLineId: (index + 1).toString(),
                        deliveryMethod: this.getDeliveryMethod().toString(),
                        totalLinePrice: product.price ? product.price : 0
                    }
                    if (subprovider?.toLocaleUpperCase() === PROVIDERS.SALESFORCE_OSU.toLocaleUpperCase()) {
                        const availableQty = product?.c_osuObjectData ? this.getAvailableQty(JSON.parse(product?.c_osuObjectData)) : 0;
                        productObj.availableQuantity = availableQty > 0 ? availableQty : 0;
                    }
                    if (product && product.price != 0) {
                        this.webReturnObject.basket['products'].push(productObj);
                    }
                }
            );
        }
        AppLoggerService.logDebug(this.className, "product", "product mapping ended...");
        return this;
    }

    linePromotion() {
        AppLoggerService.logDebug(this.className, "linePromotion", "linePromotion mapping started...");
        this.webReturnObject.basket.linePromotion = [] as LinePromotions[];
        let linePromotionArray = [] as LinePromotions[];
        if (this.orderDetails.product_items && this.orderDetails.product_items.length > 0) {
            this.orderDetails.product_items.forEach(
                (product, index) => {
                    product.item_id = (index + 1).toString();
                    if (product.price_adjustments && product.price_adjustments.length > 0) {
                        product.price_adjustments.forEach(
                            (promotion) => {
                                if (!promotion.coupon_code) {
                                    let linePromotionObj = {} as LinePromotions;
                                    let trigger = {} as Trigger;
                                    trigger.itemLineId = product.item_id;
                                    trigger.quantity = product.quantity ? product.quantity : 0;
                                    linePromotionObj.trigger = [] as Trigger[];
                                    linePromotionObj.trigger.push(trigger);

                                    linePromotionObj.itemLineId = index + 1;
                                    linePromotionObj.promotionId = promotion.promotion_id ? promotion.promotion_id : '';
                                    linePromotionObj.displayText = promotion.item_text ? promotion.item_text : '';
                                    linePromotionObj.promotionType = promotion.applied_discount && promotion.applied_discount.type ? promotion.applied_discount.type : '';
                                    linePromotionObj.promotionAmount = promotion.price ? Math.abs(promotion.price) : 0;
                                    linePromotionObj.name = promotion.coupon_code ? promotion.coupon_code : (promotion.item_text ? promotion.item_text : '');
                                    linePromotionObj.promotionInfo = promotion.item_text ? promotion.item_text : '';
                                    linePromotionObj.promotionLinePrice = product.price - Math.abs(promotion.price);
                                    linePromotionArray.push(linePromotionObj);
                                }
                            }
                        );
                    }
                }
            );
        }
        this.webReturnObject.basket.linePromotion = linePromotionArray;
        AppLoggerService.logDebug(this.className, "linePromotion", "linePromotion mapping ended...");
        return this;
    }

    transactionPromotion() {
        AppLoggerService.logDebug(this.className, "transactionPromotion", "transactionPromotion mapping started...");

        let transactionPromotionArray = this.getTransactionPromotions(this.orderDetails);

        this.webReturnObject.basket.transactionPromotion = transactionPromotionArray;
        AppLoggerService.logDebug(this.className, "transactionPromotion", "transactionPromotion mapping ended...");
        return this;
    }

    getTransactionPromotions(basket): TransactionPromotion[] {
        try {
            let transactionPromotionArray = [] as TransactionPromotion[];
            if (basket.order_price_adjustments && basket.order_price_adjustments.length > 0) {
                basket.order_price_adjustments.forEach(
                    (transactionPromotion) => {
                        let transactionPromotionObj = {} as TransactionPromotion;

                        transactionPromotionObj.displayText = transactionPromotion.item_text ? transactionPromotion.item_text : '';
                        transactionPromotionObj.name = transactionPromotion.coupon_code ? transactionPromotion.coupon_code : (transactionPromotion.item_text ? transactionPromotion.item_text : '');
                        transactionPromotionObj.promotionAmount = transactionPromotion.price ? Math.abs(transactionPromotion.price) : 0;
                        transactionPromotionObj.promotionId = transactionPromotion.promotion_id ? transactionPromotion.promotion_id : '';
                        transactionPromotionObj.promotionInfo = transactionPromotion.item_text ? transactionPromotion.item_text : '';
                        transactionPromotionObj.promotionType = transactionPromotion.applied_discount && transactionPromotion.applied_discount.type ? transactionPromotion.applied_discount.type : '';
                        transactionPromotionObj.itemLineIds = this.orderDetails.product_items.map((product, index) => index + 1);
                        if (transactionPromotion.coupon_code) {
                            transactionPromotionObj.type = PROMOTION_TYPE.COUPON;
                            transactionPromotionObj.couponCode = transactionPromotion.coupon_code;
                            transactionPromotionObj.subLevelType = PROMOTION_LEVEL.TRANSACTION;
                        }
                        transactionPromotionArray.push(transactionPromotionObj);
                    }
                );
            }


            AppLoggerService.logDebug(this.className, "getTransactionPromotions", "getTransactionPromotions : ", transactionPromotionArray);
            return transactionPromotionArray;
        } catch (error) {
            AppLoggerService.logError(this.className, "getTransactionPromotions", "failed:", error);
            throw new Error(error);
        }
    }

    updateLinePromotionWithCoupon() {
        try {

            let transactionPromotion = {} as TransactionPromotion;
            let triggerPromotion = [] as Trigger[];
            if (this.orderDetails.product_items && this.orderDetails.product_items.length > 0) {
                this.orderDetails.product_items.forEach(
                    (product, index) => {
                        product.item_id = (index + 1).toString();

                        if (product.price_adjustments && product.price_adjustments.length > 0) {
                            product.price_adjustments.forEach(
                                (promotion) => {
                                    if (promotion.coupon_code) {
                                        let trigger = {} as Trigger;
                                        trigger.itemLineId = product.item_id;
                                        trigger.quantity = product.quantity ? product.quantity : 0;
                                        trigger.totalQuantity = product.quantity ? product.quantity : 0;
                                        trigger.promotionAmount = promotion.price ? Math.abs(promotion.price) : 0;
                                        trigger.refundedReason = promotion.coupon_code ? promotion.coupon_code : '';
                                        trigger.refundedReasonDescription = promotion.item_text ? promotion.item_text : '';
                                        trigger.promotionId = promotion.promotion_id;
                                        triggerPromotion.push(trigger);
                                    }
                                }
                            );
                        }
                    }
                );
            }

            if (triggerPromotion.length > 0) {
                transactionPromotion.displayText = triggerPromotion[0].refundedReasonDescription;
                transactionPromotion.name = triggerPromotion[0].refundedReason;
                transactionPromotion.promotionAmount = -(triggerPromotion.reduce((n, { promotionAmount }) => n + promotionAmount, 0));
                transactionPromotion.promotionId = triggerPromotion[0].promotionId;
                transactionPromotion.promotionInfo = triggerPromotion[0].refundedReasonDescription;
                transactionPromotion.couponCode = triggerPromotion[0].refundedReason;
                transactionPromotion.itemLineIds = [];
                transactionPromotion.type = PROMOTION_TYPE.COUPON;
                transactionPromotion.subLevelType = PROMOTION_LEVEL.LINE;
                transactionPromotion.trigger = triggerPromotion;
            }
            AppLoggerService.logDebug(this.className, "updateLinePromotionWithCoupon", "transactionPromotion", transactionPromotion);

            if (!this.webReturnObject.basket.transactionPromotion) {
                this.webReturnObject.basket.transactionPromotion = [];
            }

            if (transactionPromotion && transactionPromotion.promotionId) {
                this.webReturnObject.basket.transactionPromotion.push(transactionPromotion);
            }

            return this;
        } catch (error) {
            AppLoggerService.logError(this.className, "updateLinePromotionWithCoupon", "linePromotion mapping=> failed:", error);
            throw new Error(error);
        }
    }

    updateTransactionPromotionPrtionCalc() {
        if (this.webReturnObject.basket.transactionPromotion && this.webReturnObject.basket.transactionPromotion.length > 0) {

            this.webReturnObject.basket.transactionPromotion.forEach(tr => {
                this.transactionPromotionProductPortionCalc(this.webReturnObject, tr)
            })
        }
        return this;
    }

    transactionPromotionProductPortionCalc(
        txDoc: TransactionDocument,
        promotion: TransactionPromotion
    ) {
        AppLoggerService.logDebug(this.className, "transactionPromotionProductPortionCalc",
            `trnsactionPromotion: ${JSON.stringify(
                promotion
            )}`
        );
        if (promotion.type === PROMOTION_TYPE.COUPON && promotion.subLevelType === PROMOTION_LEVEL.LINE) {
            txDoc.basket.products.forEach((product) => {
                product = this.validateProductItemDiscount(product);

                if (promotion.trigger && promotion.trigger.length > 0) {
                    promotion.trigger.forEach((t) => {
                        if (t.itemLineId === product.itemLineId.toString()) {
                            product.itemDiscounts.trnPromotionsPortion += t.promotionAmount;
                        }
                    });
                }
            });
        }
        else {
            txDoc.basket.products.forEach((product) => {
                product = this.validateProductItemDiscount(product);
                if (promotion.itemLineIds.includes(+product.itemLineId)) {
                    const productItem = this.orderDetails.product_items.find(productItem => productItem.product_id === product.SKU);
                    const transactionPromotionPortion = (productItem && productItem.price_after_item_discount && productItem.price_after_order_discount) ?
                        (productItem.price_after_item_discount - productItem.price_after_order_discount) : 0;
                    product.itemDiscounts.trnPromotionsPortion += this.numberUtilService.trimTo2Decimal2(transactionPromotionPortion);
                }
            });
        }
        return txDoc;
    }


    public validateProductItemDiscount(product: TProduct) {
        if (!product.itemDiscounts) {
            product.itemDiscounts = {
                trnDiscountsPortion: 0,
                trnPromotionsPortion: 0,
                refundPortion: 0,
            };
        }
        return product;
    }


    customer() {
        AppLoggerService.logDebug(this.className, "customer", "customer mapping started...");
        let customerObj = {} as Customer;
        customerObj.email = this.orderDetails.customer_info && this.orderDetails.customer_info.email ? this.orderDetails.customer_info.email : '';
        customerObj.firstName = this.orderDetails.billing_address && this.orderDetails.billing_address.first_name ? this.orderDetails.billing_address.first_name : '';
        customerObj.lastName = this.orderDetails.billing_address && this.orderDetails.billing_address.last_name ? this.orderDetails.billing_address.last_name : '';

        let shippingAddress = [] as Address[];
        this.orderDetails.shipments.forEach(
            shipment => {
                let shippingAddressObj = {} as Address;
                shippingAddressObj.id = shipment.shipping_address && shipment.shipping_address.id ? shipment.shipping_address.id : '';
                shippingAddressObj.countryCode = shipment.shipping_address && shipment.shipping_address.country_code ? shipment.shipping_address.country_code : '';
                shippingAddressObj.address1 = shipment.shipping_address && shipment.shipping_address.address1 ? shipment.shipping_address.address1 : '';
                shippingAddressObj.city = shipment.shipping_address && shipment.shipping_address.city ? shipment.shipping_address.city : '';
                shippingAddressObj.country = '';
                shippingAddressObj.postCode = shipment.shipping_address && shipment.shipping_address.postal_code ? shipment.shipping_address.postal_code : '';
                shippingAddress.push(shippingAddressObj);
            }
        )
        customerObj.shippingAddress = shippingAddress;

        let billingAddress = [] as Address[];
        let billingAddressObj = {} as Address;
        billingAddressObj.id = this.orderDetails.billing_address && this.orderDetails.billing_address.id ? this.orderDetails.billing_address.id : '';
        billingAddressObj.countryCode = this.orderDetails.billing_address && this.orderDetails.billing_address.country_code ? this.orderDetails.billing_address.country_code : '';
        billingAddressObj.address1 = this.orderDetails.billing_address && this.orderDetails.billing_address.address1 ? this.orderDetails.billing_address.address1 : '';
        billingAddressObj.city = this.orderDetails.billing_address && this.orderDetails.billing_address.city ? this.orderDetails.billing_address.city : '';
        billingAddressObj.country = '';
        billingAddressObj.postCode = '';
        billingAddress.push(billingAddressObj);
        customerObj.billingAddress = billingAddress;

        let shipmentDetails = [] as ShipmentDetails[];
        this.orderDetails.shipments.forEach(
            shipment => {
                let shipmentDetailsObj = {} as ShipmentDetails;
                shipmentDetailsObj.id = shipment.shipment_id ? shipment.shipment_id : '';
                shipmentDetailsObj.deliveryGroup = shipment.shipment_id ? shipment.shipment_id : '';
                shipmentDetails.push(shipmentDetailsObj);
            }
        );
        customerObj.shipmentDetails = shipmentDetails;

        this.webReturnObject.customer = customerObj;
        AppLoggerService.logDebug(this.className, "customer", "customer mapping ended...");
        return this;
    }

    isInStoreOrder(isInStoreOrder: boolean) {
        AppLoggerService.logDebug(this.className, "isInStoreOrder", "isInStoreOrder mapping started...");

        this.webReturnObject.isInStoreOrder = isInStoreOrder || false;

        AppLoggerService.logDebug(this.className, "isInStoreOrder", "isInStoreOrder mapping ended...");
        return this;
    }

    externalTransactionDetails() {
        AppLoggerService.logDebug(this.className, "externalTransactionDetails", "externalTransactionDetails mapping started...");
        let externalTransactionDetails = [] as externalTransactionDetails[];
        if (this.orderDetails.shipments && this.orderDetails.shipments.length > 0) {
            this.orderDetails.shipments.forEach(
                shipment => {
                    let externalTransactionDetailsObj = {} as externalTransactionDetails;
                    let transactionInfo = {} as TransactionInfo;
                    externalTransactionDetailsObj.uniqueId = this.orderDetails.order_no ? this.orderDetails.order_no : '';
                    externalTransactionDetailsObj.providerType = PROVIDERS.SALESFORCE;
                    transactionInfo.shippingId = shipment.shipping_method && shipment.shipping_method.id ? shipment.shipping_method.id : '';
                    transactionInfo.externalShippingId = shipment.shipment_id ? shipment.shipment_id : '';
                    externalTransactionDetailsObj.details = transactionInfo;
                    externalTransactionDetails.push(externalTransactionDetailsObj);
                }
            );
        }
        this.webReturnObject.externalTransactionDetails = externalTransactionDetails;
        AppLoggerService.logDebug(this.className, "externalTransactionDetails", "externalTransactionDetails mapping ended...");
        return this;
    }

    updateTaxBreakdown() {
        AppLoggerService.logDebug(this.className, "updateTaxBreakdown", "Mapping started...");

        const taxLines = this.orderDetails.product_items
            .map((product, index) => {
                const VAT = product.tax_rate ? (product.tax_rate * 100) : 0;
                const VATCode = product.tax_class_id || '';

                return {
                    itemLineId: index + 1,
                    VAT,
                    VATCode
                };
            }) || [];

        this.webReturnObject.basket["taxBreakdown"] = {
            taxLines
        };

        AppLoggerService.logDebug(this.className, "updateTaxBreakdown", `Mapped ${taxLines.length} tax lines.`);
        AppLoggerService.logDebug(this.className, "updateTaxBreakdown", "Mapping ended...");

        return this;
    }

    basketSummary() {
        AppLoggerService.logDebug(this.className, "basketSummary", "basketSummary mapping started...");
        let basketSummary = {} as BasketSummary;
        let basketSummaryWebOrder = {} as BasketSummaryDetails;
        const linePromotionTotal = this.webReturnObject.basket.linePromotion.map(linePromotion => linePromotion.promotionAmount).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        const transactionPromotionTotal = this.webReturnObject.basket.transactionPromotion.map(transactionPromotion => transactionPromotion.promotionAmount).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        basketSummary.discountTotal = linePromotionTotal + transactionPromotionTotal;
        basketSummary.VATTotal = this.orderDetails.tax_total ? this.orderDetails.tax_total : 0;
        basketSummary.saleTotal = this.orderDetails.order_total ? this.orderDetails.order_total : 0;
        basketSummary.basketTotal = this.orderDetails.order_total ? this.orderDetails.order_total : 0;
        basketSummary.totalItems = this.orderDetails.product_items && this.orderDetails.product_items.length > 0 ? this.orderDetails.product_items.length : 0;
        basketSummary.shippingTotal = this.orderDetails.shipping_total ? this.orderDetails.shipping_total : 0;
        basketSummary.basketTotalWithShippingTotal = this.orderDetails.order_total ? this.orderDetails.order_total : 0;
        basketSummaryWebOrder.shippingTotal = this.orderDetails.shipping_total ? this.orderDetails.shipping_total : 0;
        basketSummaryWebOrder.basketTotalWithShippingTotal = this.orderDetails.order_total ? this.orderDetails.order_total : 0;
        basketSummary.webOrder = basketSummaryWebOrder;
        this.webReturnObject.basketSummary = basketSummary;
        AppLoggerService.logDebug(this.className, "basketSummary", "basketSummary mapping ended...");
        return this;
    }

    deviceId(deviceId) {
        this.webReturnObject.deviceId = deviceId;
        return this;
    }

    terminalId(terminalId) {
        this.webReturnObject.terminalId = terminalId;
        return this;
    }

    orgCode(orgCode) {
        this.webReturnObject.orgCode = orgCode;
        return this;
    }

    storeId(storeId) {
        this.webReturnObject.storeId = storeId;
        return this;
    }

    storeNodeId(storeNodeId: string) {
        this.webReturnObject.storeNodeId = storeNodeId;
        return this;
    }

    storeNodeStructure(storeNodeStructure: string) {
        this.webReturnObject.storeNodeStructure = storeNodeStructure;
        return this;
    }

    docId(docId) {
        this.webReturnObject.id = docId;
        return this;
    }

    updateUserID(userID: string) {
        this.webReturnObject.userId = userID;
        return this;
    }

    updateUserName(name) {
        this.webReturnObject.userName = name;
        return this;
    }

    build() {
        AppLoggerService.logDebug(this.className, "build", "mapping done...");
        return this.webReturnObject;
    }

    getUTCDateTime(date) {
        if (date) {
            return new Date(date).toISOString();
        }
    }

    getAvailableQty(status: any): number {
        let shippedQtys = 0;
        let returnedQtys = 0;

        if (status?.SHIPPED) {
            const shipped = Object.values(status.SHIPPED);
            let shippedQty = shipped.reduce((n, { qty }) => n + ((typeof qty == 'string') ? +qty : qty), 0);
            shippedQtys += Number(shippedQty);
        }

        if (status?.RETURNED) {
            const returned = Object.values(status.RETURNED);
            let refundQty = returned.reduce((n, { qty }) => n + ((typeof qty == 'string') ? +qty : qty), 0);
            returnedQtys += Number(refundQty);
        }

        return shippedQtys - returnedQtys;
    }
}
